import React from "react";

const Footer = ({ marginTop }) => {
  return (
    <>
      <div
        style={{
          padding: "1rem",
          textAlign: "center",
          marginTop: marginTop ? marginTop + "px" : 0,
        }}
      >
        Copyright 2020 @Bevoice
      </div>
    </>
  );
};

export default Footer;
